const gccsScheduleManagerTimelineSilenceMode = {
  controller: 'SilenceModeController',
  controllerAs: 'silenceModeCtrl',
  template: require('./template.pug'),
  bindings: {
    securityManager: '<'
  }
};

angular
  .module('public.security-manager.schedule-manager.timeline')
  .component('gccsScheduleManagerTimelineSilenceMode',
    gccsScheduleManagerTimelineSilenceMode);
